import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserpilotService } from '../userpilot.service';

export const canActivateUserpilotReload: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const userpilotService = inject(UserpilotService);
  userpilotService.reload();
  return true;
};
